export function calculate_total_lost_returned() {

  let all_line = document.querySelectorAll("#clientPurchase_form_clientPurchase_vs_lost .line");
  let input_total_lost = document.querySelector("#clientPurchase_form_total_lost input");
  let input_total_returned = document.querySelector("#clientPurchase_form_total_returned input");
  let input_total_general = document.querySelector("#clientPurchase_form_general_lost input");
  let total_lost = 0;
  let total_returned = 0;
  let total_general = 0;

  if (all_line != undefined && all_line != null) {
    all_line.forEach(function (element) {
      let input_price = element.querySelector('.lost_price input');
      let price_value = (input_price.value == "" || parseFloat(input_price.value) == NaN || parseFloat(input_price.value) == 0) ? 0 : parseFloat(input_price.value);
      let input_return = element.querySelector('.return_item input');

      if (input_return.checked) {
        total_returned = total_returned + price_value;
      } else {
        total_lost = total_lost + price_value;
      }

    });
  }

  total_general = total_lost + total_returned;
  input_total_lost.value = `${parseFloat(total_lost).toFixed(2)}`;
  input_total_returned.value = `${parseFloat(total_returned).toFixed(2)}`;
  input_total_general.value = `${parseFloat(total_general).toFixed(2)}`;

}

export function calculateInvoiceTotal(data, htmlFc) {
  const input_invoice_total = document.querySelector("#clientPurchase_general_total_price");
  const inputTotalValue = input_invoice_total.querySelector("input");

  let totalItemsPrice = 0.00;
  let totalReturned = 0.00;

  if (data && data.data && data.data.length > 0) {

    const mtItems = data.multiTables[0].data ?? [];
    mtItems.forEach(m => {
      totalItemsPrice +=
        parseFloat(m.total_price) ?? 0;
    });


    const mtReturn = data.multiTables[3].data ?? [];
    mtReturn.forEach(m => {
      if (m.return_item == "true") {
        totalReturned +=
          parseFloat(m.lost_price) ?? 0;
      }
    });

    const totalValue = parseFloat(totalItemsPrice - totalReturned);
    inputTotalValue.value = totalValue.toFixed(2);

    return;
  }

  let mtItems = htmlFc.fullcontHTML.querySelector("#purchase_form_purchase_vs_item");
  let mtReturn = htmlFc.fullcontHTML.querySelector("#purchase_form_purchase_vs_lost");
  let lineitmes = mtItems.querySelectorAll('.line');
  let linereturn = mtReturn.querySelectorAll('.line') || null;

  let totalVenta = 0;
  let totalReturn = 0;

  lineitmes.forEach(l => {
    let input_qty = l.querySelector('.qty input');
    let input_unit_price = l.querySelector('.unit_price input');

    let qty = parseFloat(input_qty.value) || 0;
    let price = parseFloat(input_unit_price.value) || 0;

    totalVenta += qty * price;
  });

  if (linereturn != null) {
    linereturn.forEach(l => {
      let input_return = l.querySelector('.return_item input[type="checkbox"]');
      if (input_return.checked === true) {
        let input_lost_price = l.querySelector('.lost_price input');
        let input_lost_qty = l.querySelector('.lost_qty input');

        let price = parseFloat(input_lost_price.value) || 0;

        totalReturn += price;
      }
    })

  }

  inputTotalValue.value = (totalVenta - totalReturn).toFixed(2) || 0.00;

  return;
}